<template>
  <div v-if="!loading" class="container where-to-buy">
    <!-- <breadcrumbs :breadcrumbs="breadcrumbs" /> -->

    <h1>{{ $t('where_to_buy') }} {{ $t('list_of_distributors') }}</h1>

    <div class="filters-addresses">
      <div class="dropdown-filters">
        <select-city v-if="vendor === 'wetz' && allCities.length" :city="city" :cities="allCities" @change="changeCity" />
        <select-region v-if="vendor === 'wellfar' && allRegions.length" :region="region" :regions="allRegions" @change="changeRegion" />

        <select-specialization
          v-if="vendor === 'wellfar' && vehicleTypesForFilter.length"
          :vehicle-type="vehicleType"
          :all-vehicle-types="vehicleTypesForFilter"
          @change="changeVehicleType"
        />

        <select-distributor :distributor="distributor" :distributors="allDistriburors()" @change="changeDistr" />
      </div>
      <div class="filter-elem3">
        <a id="map-tab-id" :class="{ active: modeShowMap }" @click="changeMode(true)">На карте</a>
        <a id="list-tab-id" :class="{ active: !modeShowMap }" @click="changeMode(false)">Списком</a>
      </div>
    </div>

    <div class="tab-content scroll-to" ref="companies_list">
      <transition name="fade" mode="out-in">
        <div v-if="modeShowMap" class="tab-pane map-tab container">
          <transition name="fade" mode="out-in">
            <div v-if="!filteredCompanies.length" :key="transitionKey" class="companies-no">
              <span>Рядом с Вами нет дистрибьюторов по выбранным фильтрам. Выберите другой город.</span>
            </div>

            <companies-map
              v-else
              :key="transitionKey"
              :companies="filteredCompanies"
              :city="city"
              @show-company-detail="showCompanyDetail"
            />
          </transition>
        </div>
        <div v-else class="tab-pane list-tab container">
          <transition name="fade" mode="out-in">
            <div v-if="!filteredCompanies.length" :key="transitionKey" class="companies-no">
              <span>Рядом с Вами нет дистрибьюторов по выбранным фильтрам. Выберите другой город.</span>
            </div>
            <div v-else :key="transitionKey" id="list-id" class="list-class">
              <template v-for="(items, distr_name) in groupedCompanies">
                <company-block
                  v-for="(company, idx) in items"
                  :key="company.id"
                  :company="company"
                  :vehicle-types="allVehicleTypes"
                  :dbConfig="dbConfig"
                  @show-company-detail="showCompanyDetail"
                  show_name="true"
                />
                <!-- :show_name="idx===0" -->
              </template>
              <div class="pagination">
                <paginator
                  v-if="filteredCompanies.length"
                  :key="transitionKey"
                  :page="pageNum"
                  :items-per-page="companiesPerPage"
                  :total-items="filteredCompanies.length"
                  @change-page="changePage"
                />
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>

    <modal
      :visible="visCompanyInfo"
      @close="
        visCompanyInfo = false;
        companyDetail = null;
      "
      class="modal-company-info"
    >
      <template v-slot:header>
        <h2>
          {{ companyDetail?.name }}
        </h2>
      </template>
      <template v-slot:body>
        <CompanyInfo :company="companyDetail" :vehicle-types="allVehicleTypes" :dbConfig="dbConfig" />
      </template>
    </modal>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/breadcrumbs';

const _userLocationCookieName = 'user-location-coordinates';
const _navigatorGeolocationTimeout = 5000;
const _companiesPerPage = 10;

import { VehicleType } from '@/models/vehicle-type';
import { DbConfig } from '@/models/db-config';

import CompaniesMap from '@/components/where-to-buy/companies-map';
import CompanyBlock from '@/components/where-to-buy/company-block';
import Modal from '@/components/modal';
import CompanyInfo from '@/components/where-to-buy/company-info';
import Paginator from '@/components/paginator';
import SelectCity from '@/components/where-to-buy/select-city';
import SelectRegion from '@/components/where-to-buy/select-region';
import SelectSpecialization from '@/components/where-to-buy/select-specialization';
import SelectDistributor from '@/components/where-to-buy/select-distributor';

export default {
  components: {
    Breadcrumbs,
    CompaniesMap,
    CompanyBlock,
    Paginator,
    SelectCity,
    SelectRegion,
    SelectSpecialization,
    SelectDistributor,
    Modal,
    CompanyInfo,
  },
  data() {
    return {
      loading: true,
      modeShowMap: true,
      pageNum: 1,
      allCities: [],
      allRegions: [],
      allCompanies: [],
      allVehicleTypes: [],
      // allDistriburors: [],
      city: null,
      region: null,
      distributor: null,
      vehicleType: null,
      dbConfig: null,
      visCompanyInfo: false,
      companyDetail: null,
    };
  },
  computed: {
    breadcrumbs() {
      let breadcrumbs = [];
      breadcrumbs.push({
        name: this.$t('where_to_buy'),
        link: '',
      });
      return breadcrumbs;
    },
    companiesPerPage() {
      return _companiesPerPage;
    },
    vehicleTypesForFilter() {
      return this.allVehicleTypes.filter((x) => this.allCompanies.filter((y) => y.vehicle_types.includes(x.id)).length);
    },
    filteredCompanies() {
      let list = this.allCompanies;
      if (this.city && this.vendor === 'wetz') {
        list = list.filter((x) => x.city_display_part === this.city[0]);
      }
      if (this.region && this.vendor === 'wellfar') {
        list = list.filter((x) => x.region === this.region[0]);
      }
      if (this.distributor) {
        list = list.filter((x) => x.name.split(',')[0] === this.distributor.split(',')[0]);
      }
      if (this.vehicleType) {
        list = list.filter((x) => x.vehicle_types.includes(this.vehicleType.id));
      }
      return list;
    },
    filteredCompaniesPerPage() {
      if (this.pageNum) {
        return this.filteredCompanies.slice(this.companiesPerPage * (this.pageNum - 1), this.companiesPerPage * this.pageNum);
      }
      return this.filteredCompanies;
    },
    groupedCompanies() {
      const grp = Object.groupBy(this.filteredCompaniesPerPage, (x) => x.name.split(',')[0]);
      return grp;
    },
    transitionKey() {
      return [this.pageNum || 0, this.city ? this.city[1] : '', this.region ? this.region[1] : '', this.vehicleType?.id || ''].join('-');
    },
    vendor() {
      return process.env.VENDOR;
    },
  },
  mounted() {
    ((this.dbConfig = DbConfig.config({ count_loading: true }).first()), this.$store.dispatch('addLoading'));
    if (this.$route.params.city) {
      this.getData();
    } else {
      this.getUserLocation(this.getData);
    }
    const app = this;
    window.onpopstate = function (e) {
      app.loadPageState();
    };
  },
  methods: {
    showCompanyDetail(company) {
      this.visCompanyInfo = true;
      this.companyDetail = company;
    },
    allDistriburors() {
      const grp = Object.groupBy(this.allCompanies, ({ name }) => name.split(',')[0]);
      const res = [];
      for (const k in grp) {
        res.push(k);
      }
      return res;
    },
    getUserLocation(callback) {
      let coords = this.$cookies.get(_userLocationCookieName);
      if (coords) {
        try {
          callback(coords);
        } catch (e) {
          callback();
        }
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              coords = {
                latitude: pos.coords.latitude,
                longitude: pos.coords.longitude,
              };
              this.$cookies.set(_userLocationCookieName, coords);
              callback(coords);
            },
            () => callback(),
            { timeout: _navigatorGeolocationTimeout }
          );
        } else {
          callback();
        }
      }
    },
    getData(coords = null) {
      this.$store.dispatch('removeLoading');
      let params = {};
      if (coords) {
        params = { ...coords };
      }
      VehicleType.config({ count_loading: true })
        .get()
        .then((response) => {
          this.allVehicleTypes = response;
          this.$axios
            .$get('/user/branch/addresses/', { params: params, count_loading: true })
            .then((response) => {
              this.allCities = response.cities;
              this.allRegions = response.regions;
              this.allCompanies = response.companies;
              if (history.state.pageParams) {
                this.loadPageState();
              } else {
                if (this.$route.query.city && this.allCities.length) {
                  this.changeCity(
                    this.allCities.find((x) => x[1] === this.$route.query.city),
                    false
                  );
                } else if (this.$route.params.city && this.allCities.length) {
                  this.changeCity(
                    this.allCities.find((x) => x[1] === this.$route.params.city),
                    false
                  );
                } else if (response.closest_city) {
                  this.savePageState();
                  this.changeCity(response.closest_city);
                }
                if (this.$route.query.region && this.allRegions.length) {
                  this.changeRegion(
                    this.allRegions.find((x) => x[1] === this.$route.query.region),
                    false
                  );
                } else if (this.$route.params.region && this.allRegions.length) {
                  this.changeRegion(
                    this.allRegions.find((x) => x[1] === this.$route.params.region),
                    false
                  );
                } else if (response.closest_region) {
                  this.savePageState();
                  this.changeRegion(response.closest_region);
                }
              }
            })
            .catch(() => {})
            .finally(() => (this.loading = false));
        });
    },
    historyPushState() {
      const params = { page: this.$route.params.page };
      if (this.city) {
        params['city'] = this.city[1];
      }
      if (this.region) {
        params['region'] = this.region[1];
      }
      const newRoute = this.$router.resolve({
        path: this.$route.path,
        params: params,
        query: params,
      });
      history.pushState({}, null, newRoute.fullPath);
      this.$router.push({
        path: this.$route.path,
        query: params,
      });
    },
    changeRegion(region, setHistory = true) {
      this.region = region;
      this.pageNum = 1;
      if (setHistory) {
        this.historyPushState();
      }
      this.savePageState();
    },
    changeCity(city, setHistory = true) {
      this.city = city;
      this.pageNum = 1;
      if (setHistory) {
        this.historyPushState();
      }
      this.savePageState();
    },
    changeDistr(distr, setHistory = true) {
      this.distributor = distr;
      this.pageNum = 1;
      if (setHistory) {
        this.historyPushState();
      }
      this.savePageState();
    },
    changeMode(val) {
      this.modeShowMap = val;
      this.historyPushState();
      this.savePageState();
    },
    changePage(page) {
      this.pageNum = page;
      if (this.$refs.companies_list) {
        this.$refs.companies_list.scrollIntoView({ behavior: 'smooth' });
      }
      this.historyPushState();
      this.savePageState();
    },
    changeVehicleType(vt) {
      this.vehicleType = vt;
      this.historyPushState();
      this.savePageState();
    },
    savePageState() {
      let state = history.state;
      state.pageParams = JSON.stringify({
        modeShowMap: this.modeShowMap,
        pageNum: this.pageNum,
        city: this.city,
        region: this.region,
        vehicleType: this.vehicleType,
        distributor: this.distributor,
      });
      history.replaceState(state, null);
    },
    loadPageState() {
      if (history.state.pageParams) {
        let params = JSON.parse(history.state.pageParams);
        this.modeShowMap = params.modeShowMap;
        this.pageNum = params.pageNum;
        this.city = params.city;
        this.region = params.region;
        this.vehicleType = params.vehicleType;
        this.distributor = params.distributor;
      }
    },
  },
};
</script>

<style lang="scss">
.modal-company-info {
  .modal-header {
    margin-top: 0;

    h2 {
      font-size: 33px;
    }
    h3 {
      font-size: 29px;
    }
    h2,
    h3 {
      margin: 10px auto;
      text-align: center;
    }
  }

  .modal-container {
    width: auto !important;
    text-align: left !important;
  }
}
</style>
